import script from "./InstitutePaymentMethodPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstitutePaymentMethodPage.vue?vue&type=script&setup=true&lang=js"

import "./InstitutePaymentMethodPage.vue?vue&type=style&index=0&id=46aa7b20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46aa7b20"]])

export default __exports__